import { render, staticRenderFns } from "./StageDetails.vue?vue&type=template&id=6cb258b0"
import script from "./StageDetails.vue?vue&type=script&lang=js"
export * from "./StageDetails.vue?vue&type=script&lang=js"
import style0 from "./StageDetails.vue?vue&type=style&index=0&id=6cb258b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports